import React from 'react';
import Utils from './Utils';
import styled from 'styled-components';

const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Table = styled.table`
    width: 150%;
    min-width: 100%;
    border-collapse: collapse;

    .sticky-col {
      position: sticky;
      background-color: white;
      left: 0;
    }
    .sticky-col.email { left: 75px; }
    .sticky-col.phone_number { left: 150px; }
    .sticky-col.slack_user_id { left: 225px; }
`;

const Th = styled.th`
    padding: 5px;
    max-width: 50px;
    min-width: 50px;
    border: 1px solid #ddd;
    text-align: left;
    overflow-wrap: anywhere;
`;

const Td = styled.td`
    padding: 5px;
    max-width: 75px;
    min-width: 50px;
    border: 1px solid #ddd;
    text-align: left;
    overflow-wrap: anywhere;
`;

class AdminManageUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      updatingActorTiers: false,
      updatingSlackTiers: false,
    };
    this.handleViewUser = this.handleViewUser.bind(this);
    this.handleUpdateUserRecords = this.handleUpdateUserRecords.bind(this);
    this.handleSaveUserRecords = this.handleSaveUserRecords.bind(this);
    this.handleMakeUserAdmin = this.handleMakeUserAdmin.bind(this);
    this.handleRemoveAdmin = this.handleRemoveAdmin.bind(this);
    this.handleUpdateTiers = this.handleUpdateTiers.bind(this);
  }

  componentDidMount() {
    Utils.apiGet('/admin/view_all_users').then((response) => {
      this.setState({users: response.data.users})
    });
  }

  handleViewUser(email) {
    window.location.href = `/profile/${email}`;
  };

  handleUpdateUserRecords(event, rowIndex, columnName, source = '') {
    const { value } = event.target;
    // Create a copy of users array
    const updatedUsers = [...this.state.users];

    if (source === 'actor') {
      updatedUsers[rowIndex]['actor_spec'][columnName] = value;
    } else if (source === 'slack') {
      updatedUsers[rowIndex]['slack_spec'][columnName] = value;
    } else {
      updatedUsers[rowIndex][columnName] = value;
    }

    // Update state with the modified users array
    this.setState({ users: updatedUsers });
  }

  // Method to handle saving changes for a specific cell
  handleSaveUserRecords(e, rowIndex, columnName, source = '') {
    e.preventDefault();
    e.stopPropagation();

    let data = new FormData();
    data.append("header", columnName)
    data.append("source", source)

    let value;
    if (source === 'actor') {
      value = this.state.users[rowIndex]['actor_spec'][columnName];
    } else if (source === 'slack') {
      value = this.state.users[rowIndex]['slack_spec'][columnName];
    } else {
      value = this.state.users[rowIndex][columnName];
    }
    data.append("value", value);

    const email = this.state.users[rowIndex]['email'];
    Utils.apiPost(`/admin/update_user_records/${email}`, data)
    .then(() => {
      window.location.reload(true);
    });
  }

  handleMakeUserAdmin(email) {
    Utils.apiPost(`/admin/make_user_admin/${email}`)
    .then(() => {
      window.location.reload(true);
    });
  }

  handleRemoveAdmin(email) {
    Utils.apiPost(`/admin/remove_admin/${email}`)
    .then(() => {
      window.location.reload(true);
    });
  }

  handleUpdateTiers(source) {
    const endpoint = `/admin/update_tiers/${source}`;
    let stateKey;
    if ( source === 'actor') {
      stateKey = 'updatingActorTiers';
    } else if (source === 'slack') {
      stateKey = 'updatingSlackTiers';
    }

    Utils.apiPost(endpoint)
      .then(() => {
        this.setState({ [stateKey]: true });
        setTimeout(() => {
          this.setState({ [stateKey]: false });
          window.location.reload(true);
        }, 5000);
      });
  }

  renderUsers() {
    const sortedUsers = this.state.users.sort((a, b) => a.id - b.id);
    return (
      <TableContainer>
        <Table>
          <thead>
          <tr>
            <Th className="sticky-col">id</Th>
            <Th className="sticky-col email">email</Th>
            <Th className="sticky-col phone_number">phone_number</Th>
            <Th className="sticky-col slack_user_id">slack_user_id</Th>
            <Th>pay_ytd</Th>
            <Th>time_created</Th>
            <Th>time_updated</Th>
            <Th>is_paypal_authenticated</Th>
            <Th>is_admin</Th>
            <Th>tier_actor</Th>
            <Th>next_pay_actor</Th>
            <Th>total_accept_actor</Th>
            <Th>recent_performance_actor</Th>
            <Th>tier_slack</Th>
            <Th>next_pay_slack</Th>
            <Th>total_accept_slack</Th>
            <Th>recent_performance_slack</Th>
          </tr>
          </thead>
          <tbody>
            {sortedUsers.map((item, index) => (
            <tr key={item.id}>
              <Td className="sticky-col">{item['id']}
                <div><button onClick={() => this.handleViewUser(item['email'])}>View User {item['id']}</button></div>
              </Td>
              <Td className="sticky-col email">{item['email']}</Td>
              <Td className="sticky-col phone_number">{item['phone_number']}</Td>
              <Td className="sticky-col slack_user_id">{item['slack_user_id']}</Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['pay_ytd']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'pay_ytd')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'pay_ytd')}>Save</button>
              </Td>
              <Td>{item['time_created']}</Td>
              <Td>{item['time_updated']}</Td>
              <Td>{item['is_paypal_authenticated']}</Td>
              <Td style={{ width: '75px' }}>
                {item['is_admin']}
                {(item['email'].includes('@gridspace.com') && !item['is_admin']) && <div><button onClick={() => this.handleMakeUserAdmin(item['email'])}>Make User {item['id']} Admin</button></div>}
                {(!!item['is_admin']) && <div><button onClick={() => this.handleRemoveAdmin(item['email'])}>Remove User {item['id']} Admin</button></div>}
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['actor_spec']['tier']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'tier', 'actor')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'tier', 'actor')}>Save</button>
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['actor_spec']['next_pay']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'next_pay', 'actor')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'next_pay', 'actor')}>Save</button>
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['actor_spec']['total_accept']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'total_accept', 'actor')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'total_accept', 'actor')}>Save</button>
              </Td>
              <Td>
                <textarea 
                  style={{ width: '75px', height: '50px' }}
                  value={item['actor_spec']['recent_performance']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'recent_performance', 'actor')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'recent_performance', 'actor')}>Save</button>
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['slack_spec']['tier']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'tier', 'slack')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'tier', 'slack')}>Save</button>
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['slack_spec']['next_pay']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'next_pay', 'slack')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'next_pay', 'slack')}>Save</button>
              </Td>
              <Td>
                <input style={{ width: '75px' }}
                  value={item['slack_spec']['total_accept']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'total_accept', 'slack')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'total_accept', 'slack')}>Save</button>
              </Td>
              <Td>
                <textarea 
                  style={{ width: '75px', height: '50px' }}
                  value={item['slack_spec']['recent_performance']}
                  onChange={(e) => this.handleUpdateUserRecords(e, index, 'recent_performance', 'slack')}
                />
                <button onClick={(e) => this.handleSaveUserRecords(e, index, 'recent_performance', 'slack')}>Save</button>
              </Td>
            </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    )
  }

  render() {
    console.log(this.state.users, typeof(this.state.users))
    return (
      <div style={{ marginLeft: '50%', marginRight: '50%' }}>
        <h2 style={{ marginTop: '25px', marginBottom: '25px' }}>User Basic Information:</h2>
          {this.renderUsers()}

        <h2 style={{ marginTop: '55px' }}>Update Actor Tiers:</h2>
        <p>Click this button to update all user Actor tiers after each Actor or Bot Session.</p>
        <div>
          <button style={{ padding: '15px 30px', marginTop: '25px', marginBottom: '25px'}} onClick={() => this.handleUpdateTiers('actor')}>Update Actor Tiers</button>
          {this.state.updatingActorTiers && <div>Updating Actor Tiers...</div>}
        </div>

        <h2 style={{ marginTop: '25px' }}>Update Slack Tiers:</h2>
        <p>N. B. Updating all user Slack tiers might lead to changes to Slack channel memberships. Please consult Phoebe before you click this button!</p>
        <div>
          <button style={{ padding: '15px 30px', marginTop: '25px', marginBottom: '25px'}} onClick={() => this.handleUpdateTiers('slack')}>Update Slack Tiers</button>
          {this.state.updatingSlackTiers && <div>Updating Slack Tiers...</div>}
        </div>
      </div>
    );
  }
}

export default AdminManageUsers;